"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Providerreferralcta() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="providerreferralcta" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/medical_office_interior.png)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(222, 47%, 11%, 0.9) 0%, hsla(198, 44%, 20%, 0.7) 50%, hsla(222, 47%, 11%, 0.85) 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-32 text-center md:py-44 lg:py-[180px]">
        <div className="mb-12 transition-all duration-700 ease-out md:mb-16 opacity-100 translate-y-0" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:9k8vgw" data-ast-start="2018" data-ast-end="2204" data-attr-property-mappings="ref:labelRef"></div>
        
        <h2 className="font-serif font-default text-primary-foreground leading-[0.95] tracking-tight transition-all duration-1000 ease-out opacity-100 translate-y-0" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:6gpn07" data-ast-start="2225" data-ast-end="2614" data-attr-property-mappings="ref:headingRef" style={{
        fontFamily: 'var(--font-serif)',
        fontWeight: '400',
        fontSize: 'clamp(3.5rem, 10vw, 8.75rem)'
      }} contentEditable="false">Partner in patient care.</h2>
        
        <p className="mt-10 max-w-[560px] text-base leading-relaxed text-primary-foreground/80 transition-all duration-1000 delay-150 ease-out md:text-lg opacity-100 translate-y-0" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:3iccj6" data-ast-start="2635" data-ast-end="3151" data-attr-property-mappings="ref:bodyRef" style={{
        fontFamily: 'var(--font-default)'
      }} contentEditable="false">Chaudhry Pulmonary Associates works with referring providers to support adult patients with pulmonary and sleep-related concerns. Please fax referral information to our office or call with referral-related questions.</p>
        
        <div className="mt-12 flex flex-col items-center gap-6 transition-all duration-1000 delay-300 ease-out sm:flex-row sm:gap-8 opacity-100 translate-y-0" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:9k8vgz" data-ast-start="3172" data-ast-end="4197" data-attr-property-mappings="ref:ctaRef">
          <Link data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:afinug" data-ast-start="3567" data-ast-end="3771" data-slot="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive has-[>svg]:px-4 group h-auto rounded-lg bg-primary px-8 py-4 text-base font-medium text-primary-foreground shadow-lg hover:bg-primary/90" to="/ContactPage">
            Refer a Patient Today
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:jedngn" data-ast-start="3653" data-ast-end="3751">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </Link>
          
          <Link className="group inline-flex items-center gap-2 border-b border-primary-foreground/40 pb-1 text-sm font-medium tracking-wide text-primary-foreground transition-colors hover:border-primary-foreground" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:qomzxp" data-ast-start="3803" data-ast-end="4182" to="/ContactPage">
            Contact Our Office
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right size-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:vdeqk2" data-ast-start="4071" data-ast-end="4164">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </Link>
        </div>
        
        <p className="mt-16 font-mono text-[11px] tracking-[0.2em] text-primary-foreground/60 uppercase transition-all duration-1000 delay-500 ease-out md:text-xs opacity-100 translate-y-0" data-ast-id="f:/src/pages/ReferringProviders/sections/Providerreferralcta.tsx|sig:3iccj8" data-ast-start="4218" data-ast-end="4547" data-attr-property-mappings="ref:captionRef">Referral Contact — (412) 672-9240</p>
      </div>
    </section>;
}